var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:({
    height: '350px',
    overflow: 'auto',
  }),attrs:{"elevation":"2"}},[_c('v-fab-transition',[_c('v-btn',{staticClass:"mx-2",style:({
        position: 'absolute',
        top: '0',
        right: '0',
        margin: '10px',
        'z-index': '2',
      }),attrs:{"loading":_vm.loadingDownload,"fab":"","dark":"","small":"","color":"green"},on:{"click":function($event){return _vm.downloadThePDF()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-download ")])],1)],1),_c('pdf',{ref:"pdfSK",attrs:{"src":_vm.pdfData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }